import { ICompany } from 'app/shared/model/company.model';

export interface ILogisticRouteWaypoint {
  id?: number;
  position?: number | null;
  address?: string | null;
  latitude?: number | null;
  longitude?: number | null;
}

export interface ILogisticRouteListItem {
  id: number;
  name: string;
  originAddress?: string | null;
  originLatitude: number;
  originLongitude: number;
  destinationAddress?: string | null;
  destinationLatitude: number;
  destinationLongitude: number;
  toleranceMeters?: number | null;
  encodedPolyline?: string | null;
  distanceMeters?: number | null;
  durationSeconds?: number | null;
}

export interface ILogisticRoute {
  id?: number;
  company?: ICompany | null;
  name?: string | null;
  originAddress?: string | null;
  originLatitude?: number | null;
  originLongitude?: number | null;
  destinationAddress?: string | null;
  destinationLatitude?: number | null;
  destinationLongitude?: number | null;
  toleranceMeters?: number | null;
  encodedPolyline?: string | null;
  distanceMeters?: number | null;
  durationSeconds?: number | null;
  provider?: string | null;
  activated?: boolean | null;
  waypoints?: ILogisticRouteWaypoint[] | null;
}

export interface ILogisticRoutePreviewRequest {
  originAddress?: string | null;
  originLatitude: number;
  originLongitude: number;
  destinationAddress?: string | null;
  destinationLatitude: number;
  destinationLongitude: number;
  toleranceMeters?: number | null;
  waypoints?: ILogisticRouteWaypoint[];
}

export interface ILogisticRoutePreviewResponse {
  encodedPolyline: string;
  distanceMeters: number;
  durationSeconds: number;
  originAddress?: string | null;
  originLatitude: number;
  originLongitude: number;
  destinationAddress?: string | null;
  destinationLatitude: number;
  destinationLongitude: number;
  waypoints?: ILogisticRouteWaypoint[];
}

export const defaultValue: Readonly<ILogisticRoute> = {
  activated: true,
};
